import { REVIEWS as type } from '@/store/types';
import Reviews from '@/services/Api/Awards/Reviews';

const state = {
  data: [],
  loading: false,
};

const mutations = {
  [type.LOADING](state, data) {
    state.loading = data;
  },
  [type.SET](state, data) {
    state.data = data;
  },
  setItem(state, item) {
    const itemIndex = state.data.findIndex((r) => r.id === item.id);
    state.data.splice(itemIndex, 1, item);
  },
  [type.CLEAR]() {
    this.commit(type.SET, []);
  },
};

const actions = {
  fetchReviews({ commit }, params) {
    commit(type.LOADING, true);
    Reviews.all(params).then((response) => {
        const { status, data } = response.data;
        if (status === 200) {
          commit(type.SET, data);
        }
      })
      .finally(() => {
        commit(type.LOADING, false);
      });
  },
  setReviewer(context, reviewId) {
    return Reviews.setAsReviewer(reviewId);
  },
  unsetReviewer(context, reviewId) {
    return Reviews.unsetAsReviewer(reviewId);
  },
};

const getters = {
  hasReviews(state) {
    const items = state.data;
    return items?.length > 0;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
